import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
	login:{
		logon:"LOGIN",
		system:"System login",
		account:"Account",
		password:"Password",
		rules_name:'Please input the account ID',
		rules_password:'Please input the account password',
		account_login:'Welcome Able2Shine SMC',
	},
	home:{
		original_password:'Current password',
		new_password:'New password',
		confirm_password:'Confirm password',
		two_passwords:'Passwords do not match',
	},
    index: {
    	welcome:'Welcome to the backstage of able2shine',
		language: "Language",
		dialog_title: "Edit",
		add:"add",
		add_student:"Add Student",
		edit:"Edit",
		del:"Delete",
        hide:"Hide",
		release:"Publish",
		preservation:"Save",
		determine:"Confirm",
		cancel:"Cancel",
		submit:"Submit",
		logout:"Logout",
		sort:"Sort",
		change_password:"Change Password",
		user_name:"Username",
		return:"Return",
		operation:"Action",
		admin:"Admin",
		cn:'Chinese ',
		en:'English ',
		pleaseInput:"Input ",
		select:'Select ',
		input:'Input',
		please:'Please check the network',
		tips:'Tips',
		confirm_leave:'Are you sure you want to exit?',
		confirm_delete:'Are you sure you want to delete?',
        confirm_cancel:'Are you sure you want to cancel?',
		confirm_kaike:'Are you sure you want to start the course and send the notice?',
		confirm_kaiying:'Are you sure you want to start the camp and send the notice?',
        confirm_hide:'Are you sure you want to hide?',
        hide_success:'Successfully hide',
		delete_success:'Successfully deleted',
		revise_success:'Password has been changed.  Please use the new password.',
		add_success:'Successfully added',
		modify_success:'Changed/edited successfully',
		operation_success:'successful',
		query:'Inquiry',
		reset:'Reset',
		whole:'All',
		image_wu:'Nothing',
		upload:'Please upload ',
		copy:'Copy',
		add_subset:'Add subset',
		export:'Export',
		search:'Search',
		class_notice:'Send mail',
		info:'info',
		copy_success:'Successfully copied',
		copy_error:'Copy failed',
		add_child:'Add student',
		please_check:'Please select',
		refund:'Refund',
		button:'Button',
		seller:'Binding Sales',
		coupon:'Issue Coupons',
		history:'History',
		resend:'Resend ',
        import:'Import',
        importtemplate:'Import Template',
        in_progress_export:'In Progress Export',
	},
	system_menu:{
		catalog:'Catalog',
		menu:'Menu',
		icon:'Icon',
		link:'Link',
		secondary_menu:'Secondary Menu',
		name:'Name',
		code:'Code',
	},
	system_role:{
		role_list:'Role List',
		role_authorize:'Role assignment',
		authorize:'Assign',
		select_authorize:'Please assign a role',
		name:'Name',
		show_message:'Receive virtual class message',
        show_kickback:'Whether to display commission',
	},
	system_admin:{
		user:'Account ID',
		role:'Role',
		country:'Jurisdiction',
		re_password:'Confirm password',
		password:'Password',
		seller_type:'Type',
		parent:'Upper level',
		name:'Name',
		tel:'Tel',
		email:'Email',
		email_correct:'Correct email address',
		sale:'Sale',
		administrators:'Admin',
		sale_tishi:"(if not selected, then goes to the sales manager)",
		administrators_tishi:"(if not selected, then goes to the course manager)",
	},
	dictionary:{
		list_name:'Dictionary name',
		list_code:'Dictionary code',
		subset_list:'Subset list',
		name:'Name',
		value:'Value',
	},
	news_index:{
		type:'Article category',
		title:'Title',
		description:'Description',
		content:'Content',
		image:'Cover photo',
		video:'Video',
		news:'The article belongs to',
        jump_type:'Jump Type',
        jump_id:'Jump Id',
        cate:'Sort',
        is_top:'Topping',
	},
	adv_index:{
		title:'Title',
		description:'Recommended size',
		type:'Unique ID',
		image:'Cover photo',
		country:'What does the advertisement belong to',
		message:'Please upload the picture',
		course_id:'Course Id',
		course_type:'Course Type',
	},
	tidings_index:{
		title:'Title',
		user_type:'Type',
		content:'Content',
		view_details:'View Details',
		show_time:'Publish time',
	},
	sale_index:{
		name:'Name',
		email:'Email',
		sales_record:'Sales record',
		user_name:'Account',
		country:'Sales Department',
		password:'Password',
		re_password:'Confirm password',
		user_name3:'Account ID must contain at least 3 characters',
		password3:'Password must contain at least 3  characters',
		name3:'Name must contain at least 3  characters',
		id:'ID',
		subject:'Subject',
		price:'Unit price',
		num:'Number of students',
		discounts:'Discount',
		total:'Total price',
	},
	teacher_index:{
		name:'Name',
		thumb:'Head portrait',
		course:'Good at courses',
		description:'Description',
		content:'Content',
		user_name:'Account number',
		country:'Teacher affiliation',
		password:'Password',
		re_password:'Confirm password',
		class_description:'Teacher introduction in the course',
		video:'Video',
		facebook:'FaceBook',
		youku:'Youku',
		timetable:'Time Table',
        email:'Email',
        type:'Type',
	},
	teacher_apply:{
		first_name:'Name',
		last_name:'Last name',
		email:'Mailbox',
		phone:'Cell-phone number',
		nationality:'Nationality',
		address:'Address',
		course:'Curriculum',
		subjects:'Course details',
		history:'Teaching experience',
		style:'Style',
		resume:'Resume',
		file:'View attachments',
		date:'Date time',
        word_file:'View resume',
	},
	learning_center:{
		name:'Name',
		address:'Address',
		country:'Region',
		address_type:'Type',
        is_show:'Display on the homepage',
	},
	course_sort:{
		name:'Name',
		subset:'sub menu',
		parent_name:'upper level',
		age_age:'age',
		type:'type',
		binding:'Evaluation form',
		type_active:'Display',
		type_inactive:'Input',
		is_jingsai:'Is it a competition',
		content:'Competition description',
		syllabus:'Syllabus',
		link:'link',
	},
	course_index:{
		theme:'Subject',
		session:'Session',
		week:'Day',
		cate:'Categories',
		price:'Price',
        price_price:'Price (Dollar $)',
        price_type:'Price Tpye',
        price_type1:'RMB(￥)',
        price_type2:'USD($)',
		max_people:'Class size',
		teacher:'Teacher',
		center:'Location',
		min_age:'Minimum age',
		max_age:'Maximum age',
		age:'Age',
		type:'Type',
		start_date:'Start date',
		end_date:'End date',
		start_time:'Start time',
		end_time:'End time',
		create_time:'Time created',
		class_start:'Class Start',
		camp_start:'Camp Start',
		course_list:'Course List',
		student_list:'Student list',
		country:'Course ownership',
		date:'Date',
		startdate:'Start date',
		enddate:'End date',
		time:'Time',
		starttime:'Start time',
		endtime:'End time',
		range:'To',
		content:'Class highlight',
		no_course_dates:'No class date',
		title:'title',
		half_price:'Half-day tuition',
		full_price:'Full-day tuition',
		lunch_price:'Lunch fee',
		look_price:'Extended care fee',
		look_price1:'Extended care fee(AM)',
		look_price2:'Extended care fee(PM)',
		copy:'Copy the week',
		plus:'Plus a week',
		copy_success:'Successfully copied',
		sort:'Week',
		class_num:'Total number of classes',
		power_type:'Privacy status',
		up_0:'Offline',
		up_1:'Online',
		list_export:'Export student list',
		thumb:'Image',
		early_discount:'Early bird discount',
		early_time:'Early bird period',
		introduce:'Notes',
		zoom:'zoom',
		password:'Password',
		virtual:'Virtual',
		status:'Status',
		ongoing:'Upcoming course',
		ongoing_:'Upcoming camp',
		upcoming:'Course in progress',
		upcoming_:'Camp in progress',
		administrators:'Admin',
		youjian_title:'Email subject',
		xuanzyoujian:'Email template',
		xuanzyoujian_info:'Email template details',
		is_show_contact:'Show Communication',
		is_show_evaluation:'Show Evaluation Form',
		is_show_front:'Show Home Page',
		show:'Show',
		hide:'Hide',
		binding_seller:'Binding Administrator',
		if_notice:'Send class opening notice',
		mail_type:'Send type',
		mail_record:'Mail Record',
        sign_up_list:'Sign-up List',
        add_time:'Add time',
        field:'Field',
        required:'Required',
        field_name:'Field Name',
        is_must:'Required',
        code:'Fields can only be composed of upper and lower case letters, numbers and underscores, and cannot start with numbers',
        form_title:'Field Title',
        add_field:'Add Field',
        buy_course_num:'Number of Apply',
        sign_up:'Whether Display Sign Up',
        year:'YEAR',
        class:'Include Private Class',
        record:'Operation Records',
        course_edit:'Course Editing',
        noon_price:'Noon Care Fee',
        audition_price:'Audition Fee',
        assistant:'Teaching assistant',
        sort_sort:'sort',
        remote_course_id:'Related American courses',
        send_leave_coupon:'Should I receive a discount coupon for taking leave',
        yes:'Yes',
        no:'No',
	},
	parent_index:{
        login_user_name:'Student Account',
		country:'Region',
		referred_email:"Referrer’s email",
		referred_tel:"Referrer’s tel",
		name:'Parent Name',
		user_name:'Account ID',
		tel:'Tel',
		wechat:'Wechat ID',
		province:'City and state (province)',
		child:'Student management',
		order:'Order',
		email:'Email',
        user_email:'Student Email',
        name_child_cn:"Student's Chinese name",
        name_child:"Student's English name",
		year:"Student’s date of birth",
		thumb:'Student’s headshot',
		seller:'Sales',
		integral:'Change points',
		score_min:'Current points',
		score:'Points Surplus',
		all_get:'Total Recharge Points',
		group_type:'Membership Level',
		jiajian:'Add or subtract',
		remarks:'Notes',
		coupon_id:'Coupon',
		password:'Password',
		re_password:'Confirm Password',
		thetwo:'The two passwords are inconsistent',
        grade:'Grade',
        student_age:'Student Age',
        class_date_time:'Trial listening time',
        trial_substitute:'试听/补课',
        trial_listening:'试听',
        substitute:'补课',
        leave_count:'Leave Number',
	},
	order:{
		no:'Order No.',
		create_time:'Order date',
		name:'Class name',
		children:"Student’s name",
		total:'Amount paid',
		price:'Amount',
		classes:'drop/switch classes',
		teacher:'Teacher',
		time:'Class time',
		date:'Class date',
		on_date:'No class date',
		subject:'Subject',
		classes_name:'Classes',
		camps:'Camps',
		customer_name:"Customer's name",
		email:'Email',
		discount:'Discount amount',
		score:'Points',
		refund:'Refund amount',
		payment:'Payment method',
		refund_title:'Refund amount',
		confirm_delete:'Are you sure you want a refund?',
		notes:'notes',
		refund_name:'Refund record',
		tel:'Tel',
		referred_email:"Referrer's email",
		letter:'Confirmation Letter',
		sendconfirmation:'Are you sure to resend the confirmation letter?',
		date_time:'Order Date',
        private:'Private',
        activity:'Activity',
        works:'Works',
        work_name:'Works Name',
        work_link:'Works Link',
        child_grade:'Student Grade',
        child_age:'Student Age',
        child_name:'Student Name',
        discount_name:'Use Coupon Name',
        center:'Learning Center',
        course_date_time:'Course Start Time',
        state:'state',
        cancel:'cancel',
        normal:'normal',
        refund_fee:'refund',
        suspend:'suspend',
		first:'First Buy',
	},
	student_list:{
		course:'Course',
		parent_name:'Parent name',
		email:'Email',
		tel:'Tel',
		wechat:'Wechat name',
		name:'Student name',
		student_id:'Student ID',
		age:'Age',
		remarks:'Notes',
        parent_note:'Parent Note',
		parent_id:'Parent ID',
		have_look:'Need extended care?',
		have_lunch:'Need lunch?',
		edit_remarks:'Edit notes',
		title:'Email title',
		old_course_id:'Pre course ID',
        time:'Time',
		children_status:'Student State',
		status0:'No roll call',
		status1:'Arrived',
		status2:'Not arrived',
        fields:'Custom Fields',
        custom_edit:'Custom Edit',
        pay_price:'Actual Payment Amount',
        per_class_price:'Amount Per Lesson',
        custom_edit_price:'Edit Amount',
        cn:'China',
        en:'USA',
        remote_type:'Registration source',
	},
	mail:{
		title:'Subject',
		type:'Type',
		content:'Content',
        is_default:'Default',
	},
	journal:{
		title:'Journal',
		type:'Type',
		create_time:'Edit time',
		name:'Name',
		user_name:'Editor',
		admin_email:'Email',
		child_name:'Student name',
		score:'Points',
	},
	virtual:{
		subject:'Subject',
		number:'Number of students',
		teacher:'Teacher',
		student:'Student',
		teacher_leave:'Teacher’s time-off application',
		student_leave:'Student’s time-off application',
		private:'Private message',
		comment:'Comments for the Teacher',
		chat:'Chat',
		feedback:'Feedback for us',
		adopt:'Approve',
		reject:'Reject',
		time:'Time',
		reason:'Reason',
		feedback_name:'User',
		content:'Content',
		reply:'Reply',
		open:'Publish',
		on_open:'Do not publish',
		star:'Star',
		send:'Send',
		receive:'Receive',
		status:'Status',
		change_teacher:'Change Teacher',
		change_course:'Change Course',
		course:'Course List',
		student_list:'Student List',
		attendance:'Attendance',
		task:'Homework',
		arrived_num:'Number of people arrived',
		not_arrived_num:'Number of people haven’t arrived',
		task_name:'Title',
		task_content:'Content',
		task_file:'File',
		parent:'Parent',
		form:'Evaluation form',
		certificate:'Certificate',
		remarks:'Notes',
		seller:'Sales',
		no:'No.',
        teacher_task:'The teacher left homework',
        student_task:'Students hand in their homework',
        teacher_ratify_task:'The teacher approved the homework',
        teacher_on_task:"The teacher hasn't left his homework yet",
        leave:'time-off application',
        leave_reason:'Reason',
        leave_time:'Time',
        del_student:'Delete Student',
        user_tel:'Parent Phone',
        grade:'Grade',
        age:'Age',
        create_time:'Application Time',
        debate_evaluation:'Debate Evaluation',
	},
	virtualmaillist:{
		time:'Time',
		title:'Title',
		content:'Content',
		children:'User',
		type:'Type',
		send_type:'Sending method',
		date:'Treatment scheme',
		change:'New course time',
		preview:'Preview',
	},
	certificate:{
		title:'Title',
		code:'identification',
		image:'Certificate',
	},
	feedback_index:{
		name:'Name',
		email:'Email',
		tel:'Tel',
		content:'Feedback',
		create_time:'Time Registered',
		status:'status',
		no_reply:'No reply',
		replied:'Replied',
		reply_content:'Reply content',
		reply_success:'Reply succeeded',
        remarks:'Note',
        history:'Course Records',
        coupon_list:'Coupon',
	},
	assess:{
		title:' Listening, Speaking, Reading & Writing Comprehensive Programs for Empowering Youth Confidence & Leadership Lights, Camera, Action! ',
		student:"Student's name",
		teacher:"Teacher's name",
		class:'Class level',
		location:'Class location',
		time:'Class day & time',
		session:'Session',
		notes:"Teacher’s comments",
		sound:"Teacher’s recording",
	},
	statistic_index:{
		date:'Date',
		teacher:'Teacher',
		class_num:'Total number of classes',
		course:'Course',
		should:'The evaluation form shall be filled in',
		already:'Completed evaluation form',
	},
	student:{
		name:'Name',
		status:'Status',
		reason:'Reason',
		date:'Date',
		teacher:'Teacher',
		operator:'Editor',
		reject:'Reject',
	},
	notice_index:{
		course:'Course',
		user_name:'Name',
        tel:'Tel',
		type:'Type',
		date:'Date',
		status0:'Untreated',
		status1:'Processed',
		status3:'Ignored',
		ignore:'Ignored',
		confirm_delete:'Are you sure to ignore?',
	},
	coupon_index:{
		name:'Coupon Name',
		coupon_type:'Coupon Type',
		credit_amount:'Credit Amount',
		discount:'Discount Ratio',
		get_type:'Receiving Method',
		superposition:'Can it be superimposed',
		binding_type:'Binding Type',
		binding:'Binding(select all if not selected)',
		trigger_type:'Collection trigger type',
		service_conditions:'Service Conditions',
		menkan:'Conditions for full discount (0 unlimited)',
		all_times:'Usage Times (0 unlimited)',
		time_type:'Time Type',
		length:'Duration (days)',
        time_length:'Duration (minute)',
		time:'Time Interval',
		code:'Receiving Code',
		status:'Status',
		shuoming:'Instructions',
		user_email:'User Email',
		user_name:'User account',
        user_tel:'User Phone',
        user_id:'User ID',
		order:'Order ID',
		get_time:'Collection Time',
		use_time:'Usage Time',
		is_use:'Whether to Use',
		is_exclude:'Exclude',
        is_discount:'Proportional Discount',
        no_diejia:'Not stacked',
	},
	statistic_course:{
		max_people:'People Limit',
		student_num:'Number',
		baokelv:'Rate',
		coupon_price:'Discount',
		score:'Use Points',
		pay_price:'Paid',
        number_courses_5:'Number of courses(≥5)',
        use_5:'Use Points(≥5)',
        paid_5:'Paid(≥5)',
        total_5:'Total(≥5)',
	},
    course_private:{
        title1:'Teacher Time',
        title2:'Course',
        purchased:'Purchased',
        confirmed:'Confirmed',
        before:'Before',
        after:'After',
    },
    sharing:{
        '公司名称':'Company Name',
        '分账账号':'Sub-Account',
        '分账比例':'Revenue Sharing Ratio',
        '是否启用':'Enable Or Not',
        '最新启用时间':'Latest Activation Time',
        '实收':'Amount Received',
        '元':'Yuan',
    },
	...enLocale
}
export default en;


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js